import React, { ReactElement } from "react";
import Text from "../Text/Text";
import LinkButton from "../LinkButton/LinkButton";

interface BreadCrumbItem {
  text: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

interface BreadcrumbsProps {
  items: BreadCrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, ...rest }): ReactElement => {
  const buildLink = (
    text: string,
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void | undefined,
    index: number
  ) => {
    return onClick ? (
      <LinkButton
        key={index}
        name={text}
        style={{ fontWeight: "bold", color: "#000000", fontSize: "16px" }}
        {...rest}
        onClick={onClick}
      >
        {text}
      </LinkButton>
    ) : (
      <Text
        key={index}
        type={"body"}
        wrapper="span"
        color="#000000"
        size="16px"
        style={{
          fontWeight: "bold",
        }}
        {...rest}
      >
        {text}
      </Text>
    );
  };

  // array of items in the following format:
  //   [{
  //     Text: "My Team",
  //     Link: "/team"
  // },
  // {
  // Text: "Joe Bloggs"
  // }
  //   ]
  //
  const breadcrumbs: ReactElement[] = [];
  items.forEach((item, index) => {
    breadcrumbs.push(buildLink(item.text, item.onClick, index));
    if (index + 1 < items.length) {
      breadcrumbs.push(
        <Text
          type="body"
          color="#000000"
          size="16px"
          style={{ fontWeight: "bold" }}
          wrapper="span"
          key={index + 1 * 1024}
        >
          &nbsp;&gt;&nbsp;
        </Text>
      );
    }
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {breadcrumbs}
    </div>
  );
};

export default Breadcrumbs;
